import {
  ConfigurationDto,
  ConfigurationUpdateRequestDto,
} from 'lib_api/lib/api/gen';

export type ConfigurationFormData = ConfigurationUpdateRequestDto &
  Pick<ConfigurationDto, 'fullName'>;

export function mapToConfigurationFormData(
  configurationUpdateRequest: ConfigurationUpdateRequestDto,
  fullName: string,
): ConfigurationFormData {
  return {
    fullName,
    ...configurationUpdateRequest,
  };
}
